import Menu, { MenuItem } from 'material-ui/Menu';
import Button from 'material-ui/Button';
import * as React from 'react';
import { SyntheticEvent } from 'react';
import { findIndex, propEq } from 'ramda';

interface OwnProps {
  placeholder: string;
  style?: object;
  className?: object;
  data: Selectable[];
  onChange: Function;
  value?: string | number;
}

export interface Selectable {
  id: number;
  name: string;
  alias?: string;
}

interface MenuState {
  anchorEl: any;
  open: Boolean;
  selectedIndex: Number;
}

class SelectMenu extends React.PureComponent<OwnProps, MenuState> {
  constructor(props: OwnProps) {
    super(props);
    const { value } = props;
    this.state = {
      anchorEl: void 0,
      open: false,
      selectedIndex: this.getSelected(value),
    };
  }

  private getSelected = (value?: string | number): number => {
    const { data } = this.props;

    if (!value) {
      return -1;
    }
    return findIndex(propEq(typeof value === 'number' ? 'id' : 'name', value))(
      data
    );
  };

  private handleClick = (event: SyntheticEvent<any>) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  private handleRequestClose = () => {
    this.setState({ open: false, anchorEl: void 0 });
  };

  private handleMenuItemClick = (event: SyntheticEvent<any>, index: number) => {
    const { onChange, data } = this.props;

    this.setState({ selectedIndex: index, open: false });
    onChange(data[index]);
  };

  public render() {
    const { style, className, data } = this.props;
    const { anchorEl, open } = this.state;

    return (
      <React.Fragment>
        <Button
          aria-owns="simple-menu"
          aria-haspopup="true"
          style={{ border: '1px solid rgba(255, 255, 255, 0.12)', ...style }}
          onClick={this.handleClick}
          className={className}
        >
          {this.getButtonLabel()}
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleRequestClose}
        >
          {data.map(this.renderItem)}
        </Menu>
      </React.Fragment>
    );
  }

  public componentDidMount() {
    const { data, onChange } = this.props;
    const { selectedIndex } = this.state;

    if (data[selectedIndex.toString()]) {
      onChange(data[selectedIndex.toString()]);
    }
  }

  public componentWillReceiveProps(props: OwnProps): void {
    const { value } = props;

    if (value) {
      this.setState({ selectedIndex: this.getSelected(value) });
    }
  }

  private renderItem = (item: Selectable, key: number): JSX.Element => {
    const { selectedIndex } = this.state;

    return (
      <MenuItem
        selected={key === selectedIndex}
        onClick={(event: SyntheticEvent<any>) =>
          this.handleMenuItemClick(event, key)
        }
        key={key}
      >
        {item.alias ? item.alias : item.name}
      </MenuItem>
    );
  };

  private getButtonLabel = () => {
    const { data, placeholder } = this.props;
    const { selectedIndex } = this.state;

    if (!data[selectedIndex.toString()]) {
      return placeholder;
    }

    if (data[selectedIndex.toString()].alias) {
      return data[selectedIndex.toString()].alias;
    }

    return data[selectedIndex.toString()].name;
  };
}

export default SelectMenu;



// WEBPACK FOOTER //
// ./src/components/SelectMenu/index.tsx